export function init (dom:any, props:any) {
  dom.ligerGrid(props)
}
